// extracted by mini-css-extract-plugin
export default {"ipLists":"JTn8YkiY5L","ipList":"mohL3NqQbe"};